<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-container">
        <h1 class="logo">imweb-crawl</h1>
        <ul class="nav-menu">
          <li><router-link to="/">계정 관리</router-link></li>
          <li><router-link to="/crawl-settings">크롤링 설정</router-link></li>
          <li><router-link to="/crawl-projects">프로젝트 크롤링</router-link></li>
          <li><router-link to="/applied-projects">지원한 프로젝트</router-link></li>
          <li><router-link to="/apply-settings">지원 설정</router-link></li>
          <li><router-link to="/auto-apply-schedule">자동 지원 스케줄</router-link></li>
          <li><router-link to="/about">About</router-link></li>
        </ul>
      </div>
    </nav>
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --color-primary: #2563eb;
  --color-primary-dark: #1d4ed8;
  --color-text: #0f172a;
  --color-text-sub: #64748b;
  --color-text-light: #94a3b8;
  --color-bg-primary: #f8fafc;
  --color-bg-secondary: #f1f5f9;
  --color-bg-white: #ffffff;
  --color-border: #e2e8f0;
  --color-border-dark: #cbd5e1;
  --radius-md: 0.75rem;
  --radius-lg: 1rem;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

html {
  color-scheme: light;
}

body {
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', system-ui, sans-serif;
  background-color: var(--color-bg-secondary);
  color: var(--color-text);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: -0.01em;
}

@media (prefers-color-scheme: dark) {
  html {
    color-scheme: light !important;
  }
  
  body {
    background-color: var(--color-bg-secondary) !important;
    color: var(--color-text) !important;
  }
}

#app {
  min-height: 100vh;
}

.navbar {
  background-color: var(--color-bg-white);
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text);
  padding: 1rem 0;
  box-shadow: var(--shadow-sm);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-primary);
  letter-spacing: -0.02em;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
}

.nav-menu a {
  color: var(--color-text-sub);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  transition: var(--transition);
  padding: 0.5rem 0;
  position: relative;
}

.nav-menu a:hover {
  color: var(--color-primary);
}

.nav-menu a.router-link-active {
  color: var(--color-primary);
  font-weight: 600;
}

.nav-menu a.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--color-primary);
  border-radius: 1px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;
}

@media (max-width: 768px) {
  .nav-container {
    padding: 0 1rem;
    flex-wrap: wrap;
  }
  
  .nav-menu {
    gap: 1rem;
    overflow-x: auto;
    padding: 0.5rem 0;
  }
  
  .main-content {
    padding: 1.5rem 1rem;
  }
}
</style>
